import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import BaseDetails from 'containers/Base/BaseDetails';
import { useDispatch, useSelector } from 'react-redux';

import { attendanceActions } from 'containers/Pages/People/Attendance';
import { getAttendanceDetailsTransformed } from 'containers/Pages/People/Attendance/Selectors/attendanceSelectors';

const AttendanceDetails = ({ id, cancel }) => {
  //------------------------------Selectors---------------------------------
  const details = useSelector(state => getAttendanceDetailsTransformed(state));
  const loading = useSelector(state => state.ui.loading);
  //-----------------------Actions------------------------------------------
  const dispatch = useDispatch();
  const dispatchFetchAttendanceDetails = useCallback(
    id => dispatch(attendanceActions.fetchGridRowDetails({ id })),
    [dispatch],
  );
  useEffect(() => {
    if (id) dispatchFetchAttendanceDetails(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return (
    <BaseDetails
      header="Attendance Tracking"
      details={details}
      cancel={cancel}
      downloadable={false}
      editable={false}
      createShiftButtonComponent={true}
      loading={loading}
    />
  );
};
AttendanceDetails.propTypes = {
  id: PropTypes.string,
  cancel: PropTypes.func,
};

export default AttendanceDetails;
